const overlay = {
  init: function () {
    overlay.events();
  },

  events: function () {
    // open
    $("body").on("click", ".overlay-open", function (e) {
      let target = $(this).data("target");
      $('.overlay[data-overlay="' + target + '"]')
        .addClass("overlay--open")
        .trigger("video");
    });

    // Close on x click
    $("body").on("click", ".overlay-close", function (e) {
      e.preventDefault();
      let overlay = $(this).closest(".overlay");
      if (overlay.hasClass("overlay--open")) {
        overlay.removeClass("overlay--open").trigger("cabVideo");
        $("html").removeClass("no-scroll");
      }
    });

    // close on esc
    $(document).keydown(function (e) {
      switch (e.keyCode) {
        case 27: // Esc
          $(".overlay").removeClass("overlay--open").trigger("cabVideo");
          $("html").removeClass("no-scroll");
          break;
      }
    });

    // close if clicked outside overlay
    $(document).mouseup(function (e) {
      let container = $(".overlay__content");
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        $(".overlay").removeClass("overlay--open").trigger("cabVideo");
        $("html").removeClass("no-scroll");
      }
    });
  },
};

export default overlay;
